import {
    SuffolkRecordType,
    SuffolkRecordSubType
} from "./SuffolkRecordTypes";

import {
    IRecordTypeFeatureInfoClick,
    RecordTypeResource,
    IRecordTypeHeading,

    IMappingTextPack
} from "@esdm/map";
import { ILayerGroup } from "@esdm/map/dist/layers/groups/ILayerGroup";


let headingConfiguration = (): Array<IRecordTypeHeading> => {
    let items = new Array<IRecordTypeHeading>();

    items.push({
        recordTypeCode: SuffolkRecordType.Monument,
        recordSubTypeCode: null,
        heading: "Monument(s)"
    });

    items.push({
        recordTypeCode: SuffolkRecordType.Event,
        recordSubTypeCode: null,
        heading: "Event(s)"
    });

    items.push({
        recordTypeCode: SuffolkRecordType.Designation,
        recordSubTypeCode: null,
        heading: "Designation(s)"
    });

    items.push({
        recordTypeCode: SuffolkRecordType.Consultation,
        recordSubTypeCode: null,
        heading: "Consultation(s)"
    });

    items.push({
        recordTypeCode: SuffolkRecordType.Designation,
        recordSubTypeCode: SuffolkRecordSubType.ListedBuilding,
        heading: "Listed Building(s)"
    });

    items.push({
        recordTypeCode: SuffolkRecordType.Designation,
        recordSubTypeCode: SuffolkRecordSubType.RegisteredParksAndGardens,
        heading: "Registered Park / Garden"
    });

    items.push({
        recordTypeCode: SuffolkRecordType.Designation,
        recordSubTypeCode: SuffolkRecordSubType.ScheduledMonument,
        heading: "Scheduled Monument(s)"
    });  

    items.push({
        recordTypeCode: SuffolkRecordType.Designation,
        recordSubTypeCode: SuffolkRecordSubType.Shine,
        heading: "SHINE"
    });


    return items;
}

export class HbsmrRecordTypeResource extends RecordTypeResource {

    public constructor(
        private _mappingTextPack: IMappingTextPack,
    ) {
        super(headingConfiguration());
    }
    
    public groupByRecordSubTypeCode(recordTypeCode: string): boolean 
    {
        return (recordTypeCode.toLowerCase() === SuffolkRecordType.Designation);        
    }      

    public mapToIRecordTypeInfoClick(featureProperties: any, layerGroup: ILayerGroup): IRecordTypeFeatureInfoClick 
    {
        return {
            id: "",
            uid: featureProperties.uid,
            ref: featureProperties.ref,
            name: featureProperties.name,
            recordType: featureProperties.rectype,
            recordSubType: featureProperties.recsubtype,
            recordSubTypeCode: featureProperties.recsubtypecode,
            data: featureProperties,
            heading: this.getHeading(featureProperties.rectype, featureProperties.recsubtypecode),
            layerGroup: layerGroup
        }
    }

    public getInfoClickHtmlTemplate(recordTypeInfoClick: IRecordTypeFeatureInfoClick): string {
        let html: string = "";
        let featurePropertyNameForId = "uid";
        let layerType: string = recordTypeInfoClick.layerGroup.layerType;

        //add controller (or any arbitrary data) to the data object
        switch (recordTypeInfoClick.recordType.toLowerCase()) {
            case "mon":
                recordTypeInfoClick.data.controller = "Monument";
                break;
            case "event":
                recordTypeInfoClick.data.controller = "Event";
                break;
            case "desig":
                recordTypeInfoClick.data.controller = "Designation";
                break;
            case "cons":
                recordTypeInfoClick.data.controller = "Consultation";
                break;
        }

        html = `
                     <li>
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}"><span><i class="far fa-info-circle" aria-hidden="true"></i></span></a>
                        &nbsp;
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}">                               
                            <span>[name] ([ref])</span>               
                        </a>
                        <a class="showOnMap" title="${this._mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[id]">                                                
                            <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
                        </a>
                     </li>`;

        return html;
    }

    
} 